import type { ReactElement, ReactNode } from "react"
import { createContext, useContext } from "react"

type CpShopContextProps = {
  value: boolean
  children: ReactNode
}

export const CpShopContext = createContext<CpShopContextProps["value"]>(false)

export const useIsCpShop = () => useContext(CpShopContext)

export function CpShopContextProvider({
  value,
  children,
}: CpShopContextProps): ReactElement<CpShopContextProps> {
  return (
    <CpShopContext.Provider value={value}>{children}</CpShopContext.Provider>
  )
}

export default CpShopContext
